<template>
  <Modal
    :modalTitle="'Select Approval'"
    :modalSize="'modal-lg'"
    :id="'approveModal'"
  >
    <div class="card text-dark">
      <div class="card-body">
        <div class="d-flex flex-column justify-content-start p-4 gap-2">
          <div class="align-self-start font-weight-bold">
            Select to approve or reject the request
          </div>
          <div class="d-flex justify-content-start gap-2 mb-4">
            <input type="hidden" id="data_id" value="" />
            <input
              type="radio"
              class="btn-check approveBtn"
              id="success-outlined"
              name="options-outlined"
              value="approve"
              v-model="selectedOption"
            />
            <label class="btn btn-outline-success" for="success-outlined">
              Approve
            </label>
            <input
              type="radio"
              class="btn-check rejectBtn"
              value="reject"
              id="danger-outlined"
              name="options-outlined"
              v-model="selectedOption"
            />
            <label class="btn btn-outline-danger" for="danger-outlined">
              Reject
            </label>
          </div>
          <div class="align-self-start font-weight-bold">Remarks</div>
          <textarea
            class="form-control"
            v-model="remarks"
            :disabled="selectedOption === 'approve'"
          ></textarea>
          <small class="text-danger">{{ message ? message : "" }}</small>
          <div class="align-self-end p-2">
            <button class="btn btn-light ml-2" data-bs-dismiss="modal">
              Cancel
            </button>
            <button class="btn btn-warning ml-2" @click="submitData()">
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/ModalComponent.vue";
import { postRequest } from "@/services/RequestService";
import { nextTick } from "vue";

export default {
  inheritAttrs: false,
  components: {
    Modal,
  },
  props: {
    datas: Array,
  },

  data() {
    return {
      selectedOption: null,
      remarks: "",
      message: "",
      requestData: [],
    };
  },

  methods: {
    async submitData() {
      let dataName = document.getElementById("data_id").value;
      this.$emit("submit-data", { dataName });

      nextTick(async () => {
        if (Array.isArray(this.datas)) {
          this.requestData = {
            entity_id: this.datas[0].approvals.entity_id, // Use array find to get the ID of the object
            entity_type: this.datas[0].approvals.entity_type,
            remarks: this.remarks ? this.remarks : null,
          };
        } else {
          this.requestData = {
            entity_id: this.datas.approvals.entity_id, // Use array find to get the ID of the object
            entity_type: this.datas.approvals.entity_type,
            remarks: this.remarks ? this.remarks : null,
          };
        }

        if (this.type === null) {
          this.message = "Please select your request.";
        }

        let response = await postRequest(
          "/approvals/" + this.selectedOption,
          this.requestData,
          true
        );

        if (response.data.success) {
          this.$swal({
            icon: response.data.success ? "success" : "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(function () {
            window.location.reload();
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.gallery-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 4px;
}

.approveBtn:hover {
  background-color: green !important;
}

.rejectBtn:hover {
  background-color: red !important;
}
</style>
